import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import {
    Button,
    Dialog,
    DialogContent,
    DialogTitle,
    Grid,
    MenuItem,
} from '@material-ui/core';

import {
    SelectValidator,
    TextValidator,
    ValidatorForm,
} from 'react-material-ui-form-validator';
import { postEstudiosSolicitados } from '../../../../actions/hce/hceActions';
import { startAlerta } from '../../../../actions/ui/alertas';
import Buscador from '../../../../actions/ui/Buscador';

export const ModalIngresoEstudioSolicitado = (props) => {

    const dispatch = useDispatch();
    const { hce, estudiosMedicos } = props;
    const [value, setValue] = useState(null);
    const [estudioSeleccionado, setEstudioSeleccionado] = useState('');
    const [descripcion, setDescripcion] = useState('');


    const onSubmitHandler = () => {
    
        if (value?.idProblema > 1) {
            let data = {
                idProblema: value.idProblema,
                IdEstudiomedico: estudioSeleccionado,
                descripcion: descripcion,
                idAgenda: hce.idAgenda,
                idAfiliado: hce.idAfiliado ? hce.idAfiliado : 0,
                idAfiliadoExterno: hce.idAfiliadoExterno ? hce.idAfiliadoExterno : 0
            };
            dispatch(postEstudiosSolicitados(data));
            props.close();
        }
        else {
            dispatch(startAlerta("Debe ingresar un dianostico antes de generar un informe.", "error"))
        }

    };

    console.log(value)
    return (
        <Dialog fullWidth maxWidth="md" open={props.open} onClose={props.close}>
            <DialogTitle>{props.titulo}</DialogTitle>
            <DialogContent>
                <ValidatorForm onSubmit={onSubmitHandler}>
                    <Grid container spacing={2}>
                        <Grid
                            item
                            xs={12}
                            sm={6}
                            md={6}
                            lg={6}
                            style={{ alignSelf: 'center', paddingLeft: 16 }}
                        >
                            <Buscador
                                value={value}
                                variant="outlined"
                                setValue={(val) => setValue(val)}
                                label="NOMBRE PROBLEMA"
                                noOptionText={'No se encuentra problema'}
                                endpoint={(nombreProblema) =>
                                    `HCE/Buscador/traerProblemaPorNombre/${nombreProblema}`
                                }
                                getOptionLabel={(option) => `${option.problema} `}
                                renderOption={(option) => (
                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                        <span style={{ color: 'green' }}>
                                            {`${option.problema}`}
                                        </span>
                                        <span
                                            style={{
                                                fontSize: 12,
                                            }}
                                        ></span>
                                    </div>
                                )}
                            />
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        sm={6}
                        md={6}
                        lg={6}
                        style={{ alignSelf: 'center', paddingLeft: 16 }}
                    >
                        <SelectValidator
                            fullWidth
                            label="Seleccionar Protocolo"
                            name="protocolos"
                            value={estudioSeleccionado ? estudioSeleccionado : ''}
                            onChange={(e) => setEstudioSeleccionado(e.target.value)}
                            validators={['required']}
                            errorMessages={['Este campo es requerido']}
                        >
                            {estudiosMedicos.map((item) => (
                                <MenuItem key={item.id} value={item.id}>
                                    {`${item.descripcion}`}
                                </MenuItem>
                            ))}
                        </SelectValidator>
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        lg={12}
                        style={{ alignSelf: 'center', paddingLeft: 16 }}
                    >
                        <TextValidator
                            fullWidth
                            variant="outlined"
                            multiline
                            label="Descripcion"
                            name="descripcion"
                            value={descripcion}
                            onChange={(e) => setDescripcion(e.target.value)}
                            disabled={props.disabled}
                        />
                    </Grid>
                </Grid>
                <div
                    style={{
                        margin: '1rem 0',
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-evenly',
                    }}
                >
                    <Button variant="contained" color="primary" onClick={props.close}>
                        Cancelar
                    </Button>
                    <Button
                        type="submit"
                        variant="contained"
                        disabled={props.disabled}
                        color="primary"
                    >
                        Guardar
                    </Button>
                </div>
            </ValidatorForm>
        </DialogContent>
        </Dialog >
    )
}
